import { combineReducers } from 'redux';
import { communicationsReducer, CommunicationsState } from './communications';
import { errorReducer, ErrorState } from '@entities/error';

export interface AccountState {
	communications: CommunicationsState;
	error: ErrorState;
}

export const accountReducer = combineReducers<AccountState>({
	communications: communicationsReducer,
	error: errorReducer
});
